import {Component, OnInit} from '@angular/core';
import {Subject} from "rxjs";

type GrupoCarteiraAuditoriaVO = {
  idGrupoCarteira?: number;
  nomeGrupoCarteira?: string;
  idCarteira?: number;
  nomeCarteira?: string;
  id?: string;
  nome?: string;
  descricao?: string;
  carteiras?: string[];
}

@Component({
  selector: 'app-modal-grupo-carteira',
  templateUrl: './modal-grupo-carteira.component.html',
  styleUrls: ['./modal-grupo-carteira.component.scss']
})
export class ModalGrupoCarteiraComponent implements OnInit {

  data: GrupoCarteiraAuditoriaVO;

  page$: Subject<number> = new Subject<number>();
  totalRegistros = 0;
  paginationTotalPage = 1;
  currentPage = 1;
  pageSize = 10;
  carteirasPaginadas: string[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.data.carteiras.sort((a, b) => a.localeCompare(b));
    this.totalRegistros = this.data.carteiras.length;
    this.paginationTotalPage = Math.ceil(this.totalRegistros / this.pageSize);
    this.atualizarPaginacao();
  }

  updatePageSize($event: number): void {
    this.pageSize = $event;
    this.paginationTotalPage = Math.ceil(this.totalRegistros / this.pageSize);
    this.currentPage = 1;
    this.page$.next(1);
    this.atualizarPaginacao();
  }

  receiverPage(value: number) {
    this.currentPage = value;
    this.page$.next(value);
    this.atualizarPaginacao();
  }

  private atualizarPaginacao() {
    const inicio = (this.currentPage - 1) * this.pageSize;
    const fim = inicio + this.pageSize;
    this.carteirasPaginadas = this.data.carteiras.slice(inicio, fim);
  }
}
